/* clickable-bis-assist -- modal basics for the AMP Back in Stock popover
   (Lucas, 11 Aug round 1: notify-me in-place capture).

   The widget's #BIS_frame overlay closes only via its X control: no
   Escape, no backdrop close, and focus strands on the hidden iframe
   after close (probed live on the draft). This assist adds the three
   modal basics ON TOP of the widget's own close action -- it never
   reimplements the capture:
   - Escape (inside the iframe doc, where focus lives, + page belt)
     clicks the widget's own .action-close;
   - a click on the iframe's .modal backdrop (outside the dialog card)
     does the same;
   - any close path (X included) returns focus to the trigger that
     opened it (.BIS_trigger card links / [data-bis-notify] PDP button).

   The iframe is same-origin (widget-written document). If the app ever
   makes it cross-origin the try/catch leaves native behaviour intact --
   fail open to the widget's X, never a broken capture.

   Loaded by: clickable-collection-grid.liquid, clickable-search-results
   .liquid, clickable-product.liquid (every surface that renders a
   notify trigger, per CLAUDE.md rule 21; run-once guard per its
   corollary). */
(function () {
  'use strict';
  if (window.__ckBisAssistLoaded) return;
  window.__ckBisAssistLoaded = true;

  var lastTrigger = null;
  var watchTimer = null;

  function frameEl() { return document.getElementById('BIS_frame'); }
  function frameVisible() {
    var f = frameEl();
    return !!f && getComputedStyle(f).display !== 'none';
  }
  function closeWidget() {
    var f = frameEl();
    if (!f) return;
    try {
      var x = f.contentDocument && f.contentDocument.querySelector('a.action-close');
      if (x) x.click();
    } catch (e) { /* cross-origin: the widget's own X remains the path */ }
  }
  function wire() {
    var f = frameEl();
    if (!f) return;
    try {
      var d = f.contentDocument;
      if (!d || !d.body || d.__ckAssistWired) return;
      d.__ckAssistWired = true; /* per document -- rewired if the widget rewrites it */
      /* AUTOFILL round (Lucas, 18 Aug): the widget's capture email gets
         the email hint. Same-origin widget-written doc; the try/catch
         above already owns the cross-origin fail-open. (id/label rules
         stop at the third-party boundary — recorded in the round.) */
      d.querySelectorAll('input[type="email"], input[name*="email" i]').forEach(function (i) {
        i.setAttribute('autocomplete', 'email');
      });
      d.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' || ev.keyCode === 27) closeWidget();
      });
      d.addEventListener('click', function (ev) {
        /* the backdrop is the .modal element itself; clicks on the
           dialog card arrive on descendants and are left alone */
        var t = ev.target;
        if (t && t.classList && t.classList.contains('modal')) closeWidget();
      });
    } catch (e) { /* cross-origin: leave native behaviour */ }
  }

  /* page-level belt: if focus ever sits outside the iframe while it is
     open, Escape still closes */
  document.addEventListener('keydown', function (ev) {
    if ((ev.key === 'Escape' || ev.keyCode === 27) && frameVisible()) closeWidget();
  });

  function startWatch() {
    clearInterval(watchTimer);
    var wasVisible = false;
    watchTimer = setInterval(function () {
      if (frameVisible()) {
        wasVisible = true;
        wire();
      } else if (wasVisible) {
        clearInterval(watchTimer);
        watchTimer = null;
        if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      }
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.BIS_trigger, [data-bis-notify]');
    if (t) {
      lastTrigger = t;
      startWatch();
    }
  }, true);
})();
